import {
    getClientsRouteLoading,
    getClientsRouteReject,
    getClientsRouteRequest,
    getClientsRouteSuccess
} from "../../actions/clientsRoutes/getAll";
import { PageSize } from "../../../../config/const";

export const getClientsRoute = (formData) => async (dispatch, getState) => {
    dispatch(getClientsRouteLoading());
    try {
        const { data } = await getClientsRouteRequest(formData, getState);
        dispatch(getClientsRouteSuccess(data))
    } catch (error) {
        dispatch(getClientsRouteReject(error))
    }
    return Promise.resolve();
};